import React, { useState, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import Link from 'next/link';
import Accordian from '../../../../utils/accordion';
// import "./style.scss";
import dynamic from 'next/dynamic';
// import 'react-phone-input-2/lib/style.css';
import RequestInfoModal from '../../../common/requestInfoModal';

function Studies(props) {
	const elementRef = useRef([]);
	const islamic_data = props?.islamicData?.length ? props.islamicData[0] : null;

	let data = islamic_data?.accordion[1];
	let arabicData = [];
	if (data && Object.keys(data).length) {
		arabicData = data?.accordions?.map((key, index) => {
			return {
				heading: key.heading,
				content: key.content,
				open: false
			};
		});
	}
	
	const [arabicTitle, setArabicTitle] = useState(data.heading);
	const [arabicDescription, setArabicDescription] = useState(data.detail);
	const [arabic, setArabic] = useState(arabicData);

	data = islamic_data?.accordion[0];
	let electiveData = [];
	if (data && Object.keys(data).length) {
		electiveData = data?.accordions?.map((key, index) => {
			return {
				heading: key.heading,
				content: key.content,
				open: false
			};
		});
	}

	const [electiveTitle, setElectiveTitle] = useState(data.heading);
	const [electiveDescription, setElectiveDescription] = useState(data.detail);
	const [elective, setElective] = useState(electiveData);

	useEffect(() => {
		let element = document.getElementsByClassName('req-info')[0];
		element?.addEventListener("click", requestInfoCheck);
		return () => {
			element?.addEventListener("click", requestInfoCheck);
		};
	}, []);

	const [openRequestInfoModal, setOpenRequestInfoModal] = useState(false);

	const requestInfoCheck = () => {
		setOpenRequestInfoModal(true);
	}

	const closeModals = () => {
		setOpenRequestInfoModal(false);
	}
	return (
		<div id="studies" className="degree-page">
			{openRequestInfoModal &&
				<RequestInfoModal
					closeModals={closeModals}
				/>

			}
			<>
				<div ref={el => elementRef.current["islamic-degree-sub-header"] = el} className="islamic-degree-sub-header w3-animate-zoom">
					<img src={`${process.env.CMS_API_ORIGIN}${islamic_data?.header?.image?.url}`} alt="Islamic Studies" />
					<p>{islamic_data?.header?.title}</p>
				</div>
				<div className="container w3-animate-bottom" ref={el => elementRef.current["islamic-degree-sub-header-text"] = el}>

					<div className="row my-4">
						<div className="col-8">
							<div className="dfadfs" dangerouslySetInnerHTML={{ __html: islamic_data?.body?.content }}></div>
							<p><strong>{electiveTitle}</strong></p>
							<p>{electiveDescription}</p>
							<div>
								{elective.length ? <Accordian accordions={elective} setAccordions={setElective} /> : null}
							</div>
							<br />
							<br />
							<h5>{arabicTitle}</h5>
							<div>
								{arabic.length ? <Accordian accordions={arabic} setAccordions={setArabic} /> : null}
							</div>
						</div>
					</div>
					<div>
					</div>
				</div>
			</>
		</div>
	);
}

export default Studies;
